<template>
  <div class="mt-5">
    <div class="text-center">
      <div
        class="text-center font-weight-500 my-2"
        v-if="mode == 'maintenance'"
        style="color: red"
      >
        <p>Website Maintenance Notice</p>
        <p>
          Our website is currently undergoing updates. You may experience technical
          issues.
        </p>
        <p>
          Please bear with us as we work to improve your experience. Thank you for your
          patience!
        </p>
      </div>
      <img height="200" src="@/assets/img/logo_text.png" />
      <!-- <p class="thickerFont nameHeader">happy fish</p> -->
      <p class="student-portal-txt">Welcome to the Admin Portal</p>
    </div>
    <div class="mx-auto sign-in-box shadow-border-form p-lg-5 p-3 mt-3">
      <div class="mb-3">
        <p class="mb-1 ml-1 font-weight-500">Email</p>
        <div class="input-group mb-2">
          <input
            id="email-input"
            type="text"
            class="form-control"
            placeholder="Email"
            v-model="formData.username"
          />
        </div>
        <p id="email-format-prompt">
          Please include an '@' in the email address. this is missing an '@'
        </p>
      </div>

      <div>
        <p class="mb-1 ml-1 font-weight-500">Password</p>
        <div class="input-group mb-3">
          <input
            class="form-control"
            id="password-input"
            type="password"
            placeholder="password"
            v-model="formData.password"
            style="border-right: 0"
          />
          <div
            class="input-group-append p-0 rounded"
            id="password-hide-show"
            style="
              border: 1px solid #ced4da;
              border-left: 0px;
              border-top-left-radius: 0 !important;
              border-bottom-left-radius: 0 !important;
            "
          >
            <b-icon icon="eye-fill" font-scale="1.5" class="btn mr-3 mt-1"> </b-icon>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-2">
        <p-check class="p-default p-curve" color="primary" checked>Remember Me</p-check>
        <b-link
          @click.prevent="$bvModal.show('resetPasswordRequestModal')"
          :disabled="isSubmitting"
          :class="
            formData.username
              ? 'text-primary'
              : 'text-secondary disabled text-decoration-none pe-none'
          "
          class="font-italic link font-weight-400"
          >Forget password</b-link
        >
        <!-- forget password modal id: forget-pw-modal-->
        <!-- to reset password modal:  password-reset-modal-->
        <!-- success prompt:  password-reset-success-modal-->
      </div>

      <div class="text-center mt-4">
        <b-button
          class="btn orange-btn text-center"
          id="loginBtn"
          variant="warning"
          :disabled="isSubmitting"
          @click="signin(formData)"
        >
          <span class="">Login</span>
        </b-button>
      </div>
      <div id="error-prompt" class="text-center mt-2" v-if="error">
        {{ error }}
      </div>
    </div>
    <ResetPassword @resetSuccessfully="$bvModal.hide('resetPasswordModal')" />
    <ResetPasswordRequest :id="`resetPasswordRequestModal`" />
  </div>
</template>

<script>
import ResetPassword from "./resetPassword.vue";
import ResetPasswordRequest from "@/portal/components/common/resetPasswordRequest.vue";
import passportApi from "@/apis/passport/index";
import userMeApi from "@/apis/user/me";

export default {
  components: { ResetPassword, ResetPasswordRequest },
  data() {
    return {
      error: "",
      isSubmitting: false,
      formData: {
        username: process.env["VUE_APP_CONSOLE_LOGIN_USER"],
        password: process.env["VUE_APP_CONSOLE_LOGIN_PASSWORD"],
      },
      mode: "",
    };
  },
  mounted() {
    if (this.$route.name == "resetPassword") {
      this.$bvModal.show("resetPasswordModal");
      return;
    }
    this.getMode();
    let loginBtn = document.getElementById("loginBtn");
    loginBtn.addEventListener("click", () => {
      if (document.getElementById("email-input").value.indexOf("@") < 0) {
        document.getElementById("email-input").style.border = "2px solid red";
        document.getElementById("email-format-prompt").style.display = "block";
      } else {
        document.getElementById("email-format-prompt").style.display = "none";
        document.getElementById("email-input").style.border = "1px solid #ced4da";
      }
    });
    let eyeIcon = document.getElementById("password-hide-show");
    eyeIcon.addEventListener("click", () => {
      if (document.getElementById("password-input").type == "password") {
        document.getElementById("password-input").type = "text";
      } else {
        document.getElementById("password-input").type = "password";
      }
    });
  },

  methods: {
    getMode() {
      console.debug("GETTING MODE");
      passportApi
        .getMode()
        .then((response) => {
          console.debug("MODE RESPONSE", response);
          this.mode = response.data;
          // if(response.data == 'maintenance')
        })
        .catch((error) => {
          console.debug("MODE ERROR", error);
          if (error.response.status == 503) {
            this.mode = "maintenance";
          }
        });
    },
    sendResetPasswordLink() {
      this.isSubmitting = true;
      console.debug("sendpasswordresetlink", this.formData);
      if (!this.formData.username) {
        this.isSubmitting = false;
        this.$dialog.alert("Please enter username in form", {
          customClass: "dialog-alert",
        });
        return;
      }
      passportApi
        .sendResetPasswordLink(this.formData.username)
        .then((response) => {
          this.$dialog.alert("A reset password link has been sent to your email.", {
            customClass: "dialog-alert",
          });
        })
        .catch((error) => {
          this.$dialog.alert(error.response.data, {
            customClass: "dialog-alert",
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    signin(form) {
      this.error = "";
      this.isSubmitting = true;
      const batch = async () => {
        const result = await passportApi.signin(form);

        if (result.data.me.user_type !== "supervisor") {
          passportApi.signout();
          this.error = "Please use the supervisor account to log in.";
          return;
        }

        const authorizationToken = {
          tokens: result.data.tokens,
          me: {
            id: result.data.me.id,
            hashid: result.data.me.hashid,
            user_type: result.data.me.user_type,
            username: result.data.me.username,
            email: result.data.me.email,
            full_name: result.data.me.full_name,
            is_active: result.data.me.is_active,
          },
        };

        $cookies.set("authorizationToken", authorizationToken);

        const userMe = await userMeApi.get();
        // console.debug("userMe", userMe);

        const me = {
          id: userMe.data.id,
          hashid: userMe.data.hashid,
          user_type: userMe.data.user_type,
          username: userMe.data.username,
          email: userMe.data.email,
          full_name: userMe.data.full_name,
          is_active: userMe.data.is_active,
          position: userMe.data.position,
          created_at: userMe.data.created_at,
          updated_at: userMe.data.updated_at,
          instructor: userMe.data.instructor,
          customer: userMe.data.customer,
        };
        $cookies.set("me", me);

        let roles = [];
        for (let r of userMe.data.roles) {
          roles.push(r.name);
        }
        window.localStorage.setItem("roles", JSON.stringify(roles));

        window.localStorage.setItem(
          "permissions",
          JSON.stringify(userMe.data.permission)
        );

        // console.debug("me", me);

        const redirect = this.$route.query.redirect ? this.$route.query.redirect : "/";

        this.$router.push({ path: `${redirect}` }).catch((err) => {
          console.warn("route failed after login:", err);
        });
      };

      batch()
        .catch((error) => {
          console.warn("signin failed:", error);
          this.error = error.response.data.error_description;
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
<style scoped>
.nameHeader {
  color: #425fbc;
  font-size: 40px;
  font-weight: 700;
}

.shadow-border-form {
  box-shadow: 1px 4px 7px 0px rgb(196, 196, 196);
  border-radius: 18px;
}

.student-portal-txt {
  color: #425fbc;
  font-size: 20px;
  font-weight: 700;
}

#error-prompt {
  color: red;
}

#email-format-prompt {
  display: none;
  color: red;
}

.sign-in-box {
  width: 50%;
}

@media only screen and (max-width: 991px) {
  .sign-in-box {
    width: 90%;
  }
}
</style>
